export const createPrice = `
    mutation createPrice($input: CreatePriceInput!) {
        createPrice(input:$input) {
              id
              productId
              product {
                id
                name
              }
              recurringOption
              priceStatus
              pricingModel
              amount
              ratePlanId
              description
              billingPeriod
              createdByUsername
              createdByUser {
                name
                givenName
                familyName
                email
              }
              created
    }
}`;

export const updatePrice = `
    mutation updatePrice($input: UpdatePriceInput!) {
        updatePrice(input:$input){
              id
              productId
              product {
                id
                name
              }
              recurringOption
              priceStatus
              pricingModel
              amount
              ratePlanId
              description
              billingPeriod
              stripePriceId
              createdByUsername
              createdByUser {
                name
                givenName
                familyName
                email
              }
              created
              updated
        }
}`;

export const deletePrice = `
    mutation deletePrice($input: DeletePriceInput!) {
        deletePrice(input:$input) 
}`;
